import { Component, OnInit, ViewChild, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { RutService } from '../shared/rut.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../shared/api.service';
import { ValidatorService, rutValidator, numClienteValidator } from '../shared/validator-service.service';
import { formatDate } from '@angular/common';
import * as basicLightbox from 'basiclightbox';
import * as $ from 'jquery';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { Title } from '@angular/platform-browser';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ModalNumeroClientesComponent } from '../modales/modal-numero-clientes/modal-numero-clientes.component';

@Component({
  selector: 'app-agendamiento-hora',
  templateUrl: './agendamiento-hora.component.html',
  styleUrls: ['./agendamiento-hora.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AgendamientoHoraComponent implements OnInit {
  formData: FormGroup;
  submitted = false;
  date1: Date;
  public dataHorarios: Array<any>;
  public dataSucursales: Array<any>;
  es: any;
  data: Object;
  minDateValue = new Date();
  maxDateValue = new Date();
  invalidDates = [];
  dateSelect: Function;

  public isBrowser = isPlatformBrowser(this.platformId);
  public isServer = isPlatformServer(this.platformId);

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private rutService: RutService,
    public router: Router,
    private apiService: ApiService,
    private storage: SessionStorageService,
    private titleService: Title,
    private metaService:Meta,
    @Inject(PLATFORM_ID) private platformId: any,
    private gtmService: GoogleTagManagerService,
    private dialog: MatDialog,
  ) {
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required, Validators.pattern(ValidatorService.nombre)]],
      rut: ['', [Validators.minLength(3), Validators.maxLength(12), Validators.required, rutValidator]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(200)]],
      calendario: [null, [Validators.required]],
      horario: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      telefono: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.telefono)]],
      nCliente: ['', [Validators.required, Validators.maxLength(9), Validators.pattern(ValidatorService.numeroCliente), numClienteValidator]],
      direccion: ['', [Validators.required, Validators.pattern(ValidatorService.direccion)]],
      motivo: ['', [Validators.required, Validators.maxLength(300)]],
    });
  }

  ngOnInit(): void {
    const horas = [
      { id: 0, hour: '10:00' },
      { id: 1, hour: '10:20' },
      { id: 2, hour: '10:40' },
      { id: 3, hour: '11:00' },
      { id: 4, hour: '11:20' },
      { id: 5, hour: '11:40' },
      { id: 6, hour: '12:00' },
      { id: 7, hour: '12:20' },
      { id: 8, hour: '12:40' },
      { id: 9, hour: '13:00' },
      { id: 10, hour: '13:20' },
      { id: 11, hour: '13:40' },
      { id: 12, hour: '14:00' },
    ];

    this.titleService.setTitle('Agendamiento de Hora | Metrogas');
    this.metaService.updateTag({ name: 'description', content: 'Te invitamos a planificar tu visita a nuestra oficina de atención a clientes en Santiago, para un acceso más rápido y seguro.' });

    if (this.isBrowser) {
      if (environment.production) {
        this.gtmService.addGtmToDom();
      }
      this.apiService.LeerSucursalesAgendamiento().subscribe(res => {
        this.dataSucursales = [];
        for (var j in res) {
          if (res[j] === true) {
            this.dataSucursales.push(j)
          }
        }
      })
      this.dateSelect = function () {
        this.dataHorarios = [];
        var dia = formatDate(this.formData.value.calendario, 'yyyy-MM-dd', 'es-ES');
        if (!dia || this.formData.value.sucursal===null) return false;
        this.apiService.LeerHorasAgendamiento({ dia: dia , sucursal: this.formData.value.sucursal}).subscribe(res => {
          this.dataHorarios = [];
          var llena, rut=false, ahora = new Date(), dateHora;
          if (res.ruts.length>0){//revisamos si el rut rellenado coincide con los que ya ingresaron 2 veces el mismo día
            for (var i = 0; i<res.ruts.length; i++){
              if (res.ruts[i].rut==this.formData.value.rut){
                rut=true;
              }
            }
          }
          if (!rut){//si el rut coincide no hay horas
            for (i = 0; i < horas.length; i++) {
              llena = false;
              dateHora=new Date(dia +' '+horas[i].hour);
              if (ahora>=dateHora){//si es más tarde que la hora no se agrega
                llena=true;
              } else {
                for (var j = 0; j < res.valor.length; j++) {
                  if (res.valor[j].hora == horas[i].hour) {
                    llena = true;
                  }
                }
              }
              if (!llena) {//si la hora no está llena se agrega al dropdown
                this.dataHorarios.push(horas[i])
              }
            }
          }
          //console.log(this.dataHorarios);
        })
      }
    }

    this.maxDateValue.setDate(this.maxDateValue.getDate() + 24);

    this.es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Borrar'
    }
  }

  openexternal() {
    window.open('https://www.comisariavirtual.cl/', '_blank');
  }

  onChangeHour($event) {
    console.log('hora', $event);
  }

  lightboxDiv(claseCss) {
    const instance = basicLightbox.create(
      $(claseCss).get()[0].innerHTML, {
      closable: true
    });

    instance.show();
  }

  formatearRut(objeto) {
    objeto.target.value = this.rutService.transform(objeto.target.value);
  }

  formatearTextoRut(texto) {
    return (texto === null || texto === undefined) ? "" : this.rutService.transform(texto);
  }

  mostrarNumeroCliente() {
    const dialogRef = this.dialog.open(ModalNumeroClientesComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'childClosed') {
        this.formData.patchValue({ nCliente: result });
      }
    });
  }

  get f() { return this.formData.controls; }
  onSubmit() {
    this.spinner.show();
    this.submitted = true;

    if (this.formData.invalid) {
      this.lightboxDiv('.modal-requerido');
      this.spinner.hide();
      return;
    }
    else {
      var data = this.formData.value;
      data.numero_cliente = data.nCliente;
      data.motivo = data.motivo;
      data.rut = this.formatearTextoRut(data.rut);
      data.fecha_agendada = formatDate(data.calendario, 'yyyy-MM-dd ', 'es-ES') + data.horario + ':00';
      data.calendario = formatDate(data.calendario, 'dd/MM/yyyy ', 'es-ES')
      this.storage.store('agendamiento', data);
      this.apiService.AgregarAgendamiento(this.formData.value).subscribe(res => {
        this.spinner.hide();
        console.log('this.formData.controls = > rescatamos los value de cada inputs', this.formData.controls);
        console.log('se envio ...');
        // this.lightboxDiv('.modal-exito');
        this.router.navigateByUrl('exito-agendamiento-de-hora');
      });
    }
  }
}
